import { useRef, useState, useCallback } from 'react';

const DEFAULT_INTERVAL = 100; // ms
const DEFAULT_MAX_PROGRESS = 95;
const DEFAULT_MAX_TIME = 3000; // ms

const useFakeProgress = ({
  interval = DEFAULT_INTERVAL,
  maxProgress = DEFAULT_MAX_PROGRESS,
  maxTime = DEFAULT_MAX_TIME,
} = {}) => {
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);
  const startTimeRef = useRef(null);

  const start = useCallback(() => {
    setProgress(0);
    clearInterval(timerRef.current);
    startTimeRef.current = Date.now();
    timerRef.current = setInterval(() => {
      const elapsed = Date.now() - startTimeRef.current;
      const nextProgress = Math.min(
        maxProgress,
        Math.floor((elapsed / maxTime) * 100),
      );
      setProgress(nextProgress);
      if (elapsed >= maxTime) {
        setProgress(maxProgress);
        clearInterval(timerRef.current);
      }
    }, interval);
  }, [interval, maxProgress, maxTime]);

  const stop = useCallback(() => {
    clearInterval(timerRef.current);
    setProgress(100);
  }, []);

  const reset = useCallback(() => {
    clearInterval(timerRef.current);
    setProgress(0);
  }, []);

  return {
    progress,
    start,
    stop,
    reset,
  };
};

export default useFakeProgress;
